import { render, staticRenderFns } from "./CurrentProject.vue?vue&type=template&id=b62e8296&"
import script from "./CurrentProject.vue?vue&type=script&lang=js&"
export * from "./CurrentProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports